import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'




const stateSlice = createSlice({
    name: 'DAs/state',
    initialState: {
        drawerOpen: false,
        
        sortedColumn: () => {},
    },

    reducers: {
       
        setSortedColumn: (state, action) => {
            state.sortedColumn = action.payload
        },
        setDrawerOpen: (state) => {
            state.drawerOpen = true
        },
        setDrawerClose: (state) => {
            state.drawerOpen = false
        } 
    },
})

export const { 
   
    setDrawerOpen, 
    setDrawerClose,
    setSortedColumn
} = stateSlice.actions

export default stateSlice.reducer
